/**
 * Add routes of each module
 */
import routesAuth from '@/pages/auth/routes';
import routesDashboard from '@/pages/dashboard/routes';
import routesEstudantes from '@/pages/estudantes/routes';

const LayoutErro404 = resolve => require(['@/components/404'], resolve);
const LayoutDashboard = resolve => require(['@/components/Dashboard'], resolve);

const routes = [
  ...routesAuth,
  {
    name: 'dashboard',
    path: '/',
    component: LayoutDashboard,
    meta: {
      requiresAuth: true,
    },
    children: [
      /**
       * Add routes of each module
       */
      ...routesDashboard,
      ...routesEstudantes
    ]
  },
  {
    path: '*',
    component: LayoutErro404
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js